import { MdVerified, MdTrendingUp, MdGroups } from 'react-icons/md';
import LeadrsLogo from 'components/icons/LeadrsLogo';

function Default(props: { maincard: JSX.Element }) {
  const { maincard } = props;
  return (
    <div className="no-scrollbar relative grid h-screen w-full grid-cols-12">
      {/* Left — brand panel */}
      <div className="col-span-6 hidden h-full flex-col justify-between bg-leadrs-yellow-soft p-12 md:flex">
        <LeadrsLogo
          size={36}
          iconBg="#1D1A01"
          iconRing="#FFF4AA"
          textColor="#1D1A01"
        />

        <div>
          <h1 className="font-crimson text-[64px] leading-[1.1] text-leadrs-yellow-focus">
            La marketplace<br />du lead.
          </h1>
          <p className="mt-6 max-w-sm font-geist text-base leading-relaxed text-leadrs-yellow-focus/70">
            Achetez et vendez des leads qualifiés, vérifiés, RGPD compliant.
            Simplement.
          </p>
          <div className="mt-10 space-y-4">
            {(
              [
                { Icon: MdVerified, label: 'Leads vérifiés et scorés' },
                { Icon: MdTrendingUp, label: 'Disponibilités en temps réel' },
                { Icon: MdGroups, label: 'Protection acheteur et vendeur' },
              ] as const
            ).map(({ Icon, label }) => (
              <div key={label} className="flex items-center gap-3">
                <Icon size={18} className="text-leadrs-yellow-focus/50" />
                <span className="font-geist text-sm text-leadrs-yellow-focus/80">{label}</span>
              </div>
            ))}
          </div>
        </div>

        <p className="font-geist text-xs text-leadrs-yellow-focus/30">
          © {new Date().getFullYear()} Leadrs.co — Tous droits réservés.
        </p>
      </div>

      {/* Right — form */}
      <div className="col-span-12 overflow-y-auto bg-white md:col-span-6">
        {maincard}
      </div>
    </div>
  );
}

export default Default;
